class ThisToysBuyNow extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
  }

  handleClick = async () => {
    const button = this.button;
    const form = this.closest('form');
    if (!button || !form || !form.checkValidity()) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Going to checkout…';

    try {
      const formData = new FormData(form);
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });

      if (!response.ok) throw new Error('Unable to start checkout');
      window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
    } catch (error) {
      button.disabled = false;
      button.textContent = originalText || 'Buy now';
      const liveRegion = this.closest('product-form-component')?.querySelector('[aria-live="assertive"]');
      if (liveRegion) liveRegion.textContent = 'Unable to start checkout. Please try again.';
    }
  };
}

if (!customElements.get('this-toys-buy-now')) {
  customElements.define('this-toys-buy-now', ThisToysBuyNow);
}
